export default __webpack_public_path__ + "static/media/laptop.cd77d0eb.png";